import { countryGeocodeName } from './countries';

export function buildGeocodeQuery(
  street: string,
  houseNumber: string,
  city: string,
  country: string
): string | null {
  const streetParts: string[] = [];
  const trimmedStreet = street.trim();
  if (trimmedStreet) {
    const house = houseNumber.trim();
    streetParts.push(house ? `${trimmedStreet} ${house}` : trimmedStreet);
  }

  const trimmedCity = city.trim();
  if (trimmedCity) streetParts.push(trimmedCity);

  const trimmedCountry = country.trim();
  if (trimmedCountry) streetParts.push(countryGeocodeName(trimmedCountry));

  return streetParts.length > 0 ? streetParts.join(', ') : null;
}

/**
 * Country is deliberately excluded: it is a fixed enum that is always populated, so it says
 * nothing about whether the user actually entered an address.
 */
export function hasAnyAddressField(
  street: string,
  houseNumber: string,
  city: string
): boolean {
  return [street, houseNumber, city].some(v => v.trim().length > 0);
}

export function isCompleteAddress(
  street: string,
  houseNumber: string,
  city: string,
  country: string
): boolean {
  return street.trim().length > 0 && city.trim().length > 0 && country.trim().length > 0;
}

/**
 * Lenders need a full address: the backend also requires a house number before their listings
 * become visible and rentable.
 */
export function isCompleteLenderAddress(
  street: string,
  houseNumber: string,
  city: string,
  country: string
): boolean {
  return isCompleteAddress(street, houseNumber, city, country) && houseNumber.trim().length > 0;
}
